import React from 'react'
import {  Stack } from '@mui/material'
import {logo} from '../utils/constant'
import { Link } from 'react-router-dom'
import SearchBar from "./SearchBar";
const Navbar = () => 
   (
    <Stack direction="row" alignItems='center'
     sx={{position:'sticky',top:'0',background:'DarkSlateBlue',justifyContent:"space-between",zIndex:"500"}}>
   <Link to="/" style={{display:'flex',alignItems:'center'}} >
    <img src="/logo.jpg" alt="#" height={45}  />
   </Link>
   <SearchBar />
    </Stack>
  )


export default Navbar